export class ErrorResponse {
  errors: Error[];
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/model/errorResponse.ts